var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayCircle = function SvgPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 29 29"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#playCircle_svg__a)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 63.526,
    height: 63.526,
    x: -17.263,
    y: -17.263
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      clipPath: "url(#playCircle_svg__b)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#playCircle_svg__c)",
    d: "M14.5 29C22.508 29 29 22.508 29 14.5S22.508 0 14.5 0 0 6.492 0 14.5 6.492 29 14.5 29",
    "data-figma-bg-blur-radius": 17.263
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#playCircle_svg__d)",
    stroke: "url(#playCircle_svg__e)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.577,
    d: "M11.154 15.548v-2.487c0-2.458 0-3.687.788-4.107.789-.42 1.808.267 3.848 1.64l1.934 1.303c1.73 1.165 2.594 1.747 2.576 2.559s-.907 1.356-2.684 2.445l-1.935 1.184c-2.004 1.227-3.007 1.84-3.767 1.415s-.76-1.601-.76-3.952"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "playCircle_svg__c",
    x1: 14.5,
    x2: 14.5,
    y1: 0,
    y2: 46.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070409",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494949",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "playCircle_svg__d",
    x1: 15.727,
    x2: 15.615,
    y1: 8.832,
    y2: 29.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "playCircle_svg__e",
    x1: 15.727,
    x2: 15.615,
    y1: 8.832,
    y2: 26.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#848484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "playCircle_svg__b",
    transform: "translate(17.263 17.263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 29C22.508 29 29 22.508 29 14.5S22.508 0 14.5 0 0 6.492 0 14.5 6.492 29 14.5 29"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "playCircle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h29v29H0z"
  })))));
};
export default SvgPlayCircle;